export enum VGL_ERROR_CODE {
  // General
  GENERAL_GENERIC = '1',
  GENERAL_ERROR_HANDLER_CONSTRUCTOR = '2',
  GENERAL_UNHANDLED_START_CALCULATION_ERROR = '3',
  GENERAL_404 = '4',
  GENERAL_SETUP = '5',
  GENERAL_UNEXPECTED_EMPTY_RESPONSE = '6',

  // Print / Mail
  PRINT_NO_TEMPLATE_SELECTED = '100',
  PRINT_SUBMIT = '101',
  PRINT_NO_DEFAULT_TEMPLATE_LOADED = '102',

  // Feature: broker
  BROKER_LOADING_FAILED = '200',
  BROKER_LOADING_RIGHTS_FAILED = '201',
  BROKER_LOADING_SETTINGS_FAILED = '202',
  BROKER_SAVING_SETTINGS_FAILED = '203',
  BROKER_ID_NOT_SET = '204',
  BROKER_SOFTFAIR_TRANSMIT_FAILED = '205',

  // Feature: choicesLists
  CHOICES_SIMPLE_LOADING_FAILED = '300',
  CHOICES_API_LOADING_FAILED = '301',
  CHOICES_API_WRONG_API_RESPONSE = '302',
  CHOICES_API_MISSING_ENDPOINT = '303',
  CHOICES_SIMPLE_UNREGISTERED = '304',

  // Feature: clients
  CLIENTS_LOADING_FAILED = '400',
  CLIENTS_SAVING_FAILED = '401',
  CLIENTS_MISSING_VN = '402', // Versicherungsnehmer
  CLIENTS_MISSING_VP = '403', // Versicherte Person
  CLIENTS_MISSING_ZP = '404', // Zahlperson
  CLIENTS_MISSING_MP = '405', // Mitversicherter Partner
  CLIENTS_GET_BY_REF_ID_FAILED = '406',
  CLIENTS_MISSING_ENTITY = '407',

  // Feature: companies
  COMPANIES_LOADING_FAILED = '500',
  COMPANIES_SPECIAL_LOADING_FAILED = '501',

  // Feature: features
  FEATURES_LOADING_FAILED = '600',
  FEATURES_TARIFF_LOADING_FAILED = '601',
  FEATURES_GET_COMPONENT_FAILED = '602',
  FEATURES_MISSING = '603',

  // Feature: global
  GLOBAL_LOADING_FAILED = '700',
  GLOBAL_INITIALIZATION_FAILED = '701',
  GLOBAL_NO_SPARTE = '702',

  // Feature: mail
  MAIL_TEMPLATES_LOADING_FAILED = '800',
  MAIL_TEMPLATES_LOADING_DEFAULT_FAILED = '801',
  MAIL_TEMPLATES_LOADING_PLACEHOLDERS_FAILED = '802',
  MAIL_TEMPLATES_GENERATE_PREVIEW_FAILED = '803',
  MAIL_TEMPLATES_STORING_FAILED = '804',
  MAIL_TEMPLATES_UPDATING_FAILED = '805',
  MAIL_TEMPLATES_DELETING_FAILED = '806',
  MAIL_MISSING_EDITOR_REF = '807',

  // Feature: profile
  PROFILE_LOADING_FAILED = '900',
  PROFILE_STORING_FAILED = '901',
  PROFILE_UPDATING_FAILED = '902',
  PROFILE_DELETING_FAILED = '903',
  PROFILE_LOADING_SELECTED_FAILED = '904',
  PROFILE_NOT_FOUND = '905',

  // Feature: quote
  QUOTE_LOADING_FAILED = '1000',
  QUOTE_STORING_FAILED = '1001',
  QUOTE_TRANSFORMATION_FAILED = '1002',
  QUOTE_GENERATE_INVENTORY_CONTRACT_FAILED = '1003',
  QUOTE_WEBREPORT_LOADING_FAILED = '1004',
  QUOTE_INVALID_INPUT_DATA = '1005',
  QUOTE_INVENTORY_CONTRACT_LOADING_FAILED = '1006',
  QUOTE_WEBREPORT_NOT_FOUND = '1007',

  // Feature: tariffs
  TARIFFS_LOADING_FAILED = '1100',
  TARIFFS_LOADING_CHUNK_FAILED = '1101',
  TARIFFS_CONTRACT_TARIFF_NOT_FOUND = '1102',
  TARIFFS_LOADING_SPECIAL_FAILED = '1103',

  // Feature: validation
  VALIDATION_MISSING_LOCALE = '1200',

  // Router
  ROUTER_INVALID_STEPS = '1300',
  ROUTER_LOADING_ROUTE_FAILED = '1301',

  // Service: API
  API_AXIOS_ERROR = '1400',

  // Utils: validation
  UTIL_VALIDATE_ALL_FAILED = '1500',
  UTIL_VALIDATE_AT_FAILED = '1501',
  UTIL_CREATE_VALIDATOR_FAILED = '1502',
  UTIL_CREATE_VALIDATE_STATE_FAILED = '1503',

  // Distribution
  DISTRIBUTION_REQUEST_INVALID_TARIFF = '1600',
  DISTRIBUTION_LOADING_FAILED = '1601',
  DISTRIBUTION_NO_VALID_TARIFF_RECOMMENDED = '1602',
  DISTRIBUTION_SAVING_FAILED = '1603',
  DISTRIBUTION_SELECTED_POOL_NOT_FOUND = '1604',
  DISTRIBUTION_POOL_CALLBACK_FAILED = '1605',

  // Feature: BankInformation
  BANK_LOADING_FAILED = '1700',
  BANK_VALIDATION_LOADING_FAILED = '1701',

  // Feature: Files
  FILES_LOADING_FAILED = '1800',

  // Utils: form
  UTIL_FORM_MISSING_CLIENT_STORE = '1900',
  UTIL_FORM_MISSING_INPUT_STORE = '1901',
  UTIL_FORM_MISSING_CONTRACT_STORE = '1902',
  UTIL_FORM_MISSING_CLIENT_ROLE = '1903',

  // Contract Page
  CONTRACT_PAGE_PROPERTY_UNKNOWN_PREVIOUS_DAMAGE = '2000',
  CONTRACT_PAGE_PROPERTY_UNKNOWN_PREVIOUS_INSURANCE = '2001',

  // Feature: PreviousInsurance
  PREVIOUS_INSURANCE_CAN_CANCEL_CHECK_FAILED = '2100',
  PREVIOUS_INSURANCE_LOADING_PRELIMINARY_CONTRACT_FAILED = '2101',

  // Feature Contract
  CONTRACT_GENERATE_FAILED = '2200',
  CONTRACT_BUILD_DATA_FAILED = '2201',
  CONTRACT_VN_HAS_NO_ID = '2202',
  CONTRACT_NO_RESPONSE_DATA = '2203',

  // Tracking
  TRACKING_INSTALLATION_FAILED = '2300',
  TRACKING_NOT_INITIALIZED = '2301',

  // Logger
  LOGGER_PARSING_FAILED = '2400',

  // Company Questions
  COMPANY_QUESTION_MISSING_VALIDATION_DEFINITION = '2500',
  COMPANY_QUESTION_MISSING_FRONTEND_KEY_FOR_SPARTE = '2501',
  COMPANY_QUESTION_FAILED_TO_LOAD_QUESTIONS = '2502',
  COMPANY_QUESTION_ACCESSING_INVALID_ID = '2503',

  // Feature: EVB Service
  EVB_LOADING_FAILED = '2600',
  EVB_REQUEST_FAILED = '2601',
  EVB_PRINT_SUBMIT_MISSING_VN = '2602',
  EVB_SOFTFAIR_DISTRIBUTION_TRANSMISSION_FAILED = '2603',
  EVB_INSURANCE_ID_LOOKUP_FAILED = '2604',

  // TypeAhead
  TYPE_AHEAD_LOADING_FAILED = '2700',

  // WkzSelection
  WKZ_SELECTION_FAILED = '2800',

  // LocalStorage
  LOCAL_STORAGE_TRANSFER_FAILED = '2900',

  // KFZ
  KFZ_SETUP = '3000',

  // InputMapping
  INPUT_MAPPING_LOADING_FAILED = '3100',
  INPUT_MAPPING_CONFIG_MISSING = '3101',
  INPUT_MAPPING_MISSING_VN = '3102',
  INPUT_MAPPING_UNKNOWN_PATH_SOURCE_LOOKUP = '3103',

  // PKV Previous Insurance
  PKV_PREVIOUS_INSURANCE_LOADING_FAILED = '3200',

  // VehicleData
  VEHICLE_DATA_LOOKUP_FAILED = '3300',

  // ComplexSelect
  COMPLEX_SELECT_COMPANY_LOADING_FAILED = '3400',
  COMPLEX_SELECT_VALUES_LOADING_FAILED = '3401',

  // EntityManager
  ENTITY_MANAGER_MISSING_STORE_FUNCTION = '3500',

  // AI
  AI_DOCUMENT_UPLOAD_FAILED = '3600',

  // Versicherungsangaben
  VA_LOADING_FAILED = '3700',
  VA_STORING_FAILED = '3701',
  VA_CLOSE_FAILED = '3702',
  VA_UPDATE_FAILED = '3703',
}
